import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import MailsDetailsSectionInfo from './sections/MailsDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<MailsDetailsSectionInfo {...props} />
		</>
	)
};

export default dialogSettings;
